import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  StapleTable,
  StapleTableBody,
  StapleTableCell,
  StapleTableHeader,
  StapleTableHeading,
  StapleTableRow,
} from '@insurancemenu/imenu-components-lib';
import FavoriteProposalStepController from 'store/modules/initiate-quote/favoriteProposalStepController';
import { FAVORITE_PROPOSAL_SUMMARY_TABLE_TEST_ID } from '../../constants';
import {
  GuidelinesContentStyled,
  GuidelineStyled,
  IMSelectStyled,
  PortfolioNamesCellStyled,
  ProductLineTitleStyled,
} from './styles';

interface Props {
  favoriteProposalStepController: FavoriteProposalStepController;
}

const FavoriteProposalPlansTable: React.FC<Props> = observer(({ favoriteProposalStepController }) => {
  const { cartItemNamesByProductLineId } = favoriteProposalStepController;

  return (
    <StapleTable
      totalElements={cartItemNamesByProductLineId.length}
      minHeight="30rem"
      data-test-id={FAVORITE_PROPOSAL_SUMMARY_TABLE_TEST_ID}
      showRowHover={false}
    >
      <StapleTableHeader>
        <StapleTableRow>
          <StapleTableHeading width="30%">Product Line</StapleTableHeading>
          <StapleTableHeading width="70%">Plans</StapleTableHeading>
        </StapleTableRow>
      </StapleTableHeader>
      <StapleTableBody>
        {cartItemNamesByProductLineId.map((row) => (
          <StapleTableRow key={row.productLineId}>
            <StapleTableCell width="30%">
              <ProductLineTitleStyled productLineId={row.productLineId} />
            </StapleTableCell>
            <StapleTableCell width="70%">
              <PortfolioNamesCellStyled>
                {row.portfolioNames.map((portfolioName) => (
                  <span key={portfolioName}>{portfolioName}</span>
                ))}
              </PortfolioNamesCellStyled>
            </StapleTableCell>
          </StapleTableRow>
        ))}
      </StapleTableBody>
    </StapleTable>
  );
});

const FavoriteProposalsView: React.FC<Props> = observer(({ favoriteProposalStepController }) => {
  const { favoriteProposalOptions } = favoriteProposalStepController;

  return (
    <>
      <div>
        <IMSelectStyled label="Favorite Proposal Name" name="cartId" size="full" options={favoriteProposalOptions} />
        <GuidelineStyled
          labels={{
            opened: 'Need to manage favorite proposals?',
            closed: 'Need to manage favorite proposals?',
          }}
          content={
            <GuidelinesContentStyled>
              To review, update or remove favorite proposals, open the <b>Tools</b> dropdown in the header and select{' '}
              <b>Favorite Proposals</b> or open the{' '}
              <a href="/favorite-proposals" target="_blank" rel="noopener noreferrer">
                Favorite Proposals page
              </a>{' '}
              in a new tab.
            </GuidelinesContentStyled>
          }
        />
      </div>
      <FavoriteProposalPlansTable favoriteProposalStepController={favoriteProposalStepController} />
    </>
  );
});

export default FavoriteProposalsView;
